import request from '@/utils/request'
import Vue from 'vue'

//病虫害分页列表
export function pageList(data) {
  return request({
    method: 'POST',
    url: Vue.prototype.baseURL + '/disease/crop-disease-library/pageList',
    data
  })
}
//详情
export function details(data) {
  return request({
    method: 'POST',
    url: Vue.prototype.baseURL + '/disease/crop-disease-library/details',
    data
  })
}

// 获取病虫害类型编码
export function diseaseAndPestCode(data) {
  return request({
    method: 'POST',
    url: Vue.prototype.baseURL + '/disease/crop-disease-library/diseaseAndPestCode',
    data
  })
}







